export const defaultHeaders = ()=>{
    let headers = new Headers();
    headers.append('X-XSRF-TOKEN', document.getElementsByName("__RequestVerificationToken")[0].value);
    if (window.kioskCredentials) {
        headers.append('Authorization', `Basic ${btoa(window.kioskCredentials.Username + ':' + window.kioskCredentials.Password)}`);
    }
    return headers;
};
export const defaultGetOptions = ()=>({
        method: 'GET',
        credentials: 'include',
        headers: defaultHeaders()
    });
export const handle = async (res, converter)=>{
    if (400 <= res.status && res.status < 500) return {
        kind: 'unauthorized',
        status: res.status
    };
    if (res.status >= 500) return {
        kind: 'failed',
        status: res.status
    };
    const apiResult = await res.json();
    const result = {
        kind: 'result',
        status: 200,
        value: converter ? converter(apiResult) : apiResult
    };
    return result;
};
export const previousOrDefault = (asyncState, defaultValue)=>asyncState.kind == 'loaded' ? asyncState.value : defaultValue;
export const ready = (asyncState)=>asyncState.kind == 'loaded' || asyncState.kind == 'loading';
export const transitionedToLoaded = (from, to)=>from.kind != 'loaded' && to.kind == 'loaded';
// During development, the Kiosk is showing the acceptance environment which is protected via Basic Auth
// The Kiosk is unable to pass basic auth as a header, so it uses basic auth in the URL
// This works for the document request, but breaks for subsequent API requests
// This function removes the URL based basic auth, which is later on replaced by a header
export const cleanFetch = (input, init)=>fetch(location.origin + input, init);
export const genericGet = (endpoint, converter)=>async ()=>{
        const response = await cleanFetch(endpoint, defaultGetOptions());
        const temp = await handle(response, converter);
        if (temp.kind != 'result') return temp;
        return {
            ...temp,
            value: temp.value
        };
    };
